import React from "react";

interface HpIconProps {
  selected?: boolean;
  width?: number;
  height?: number;
}

export const HpProfileIcon: React.FC<HpIconProps> = ({
  selected = false,
  width = 24,
  height = 24,
}) => {
  const fillColor = selected ? "#001CB0" : "#1A1A1A";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7137 3.00834C11.6938 3.01016 11.6249 3.01651 11.5596 3.02104C11.4952 3.02648 11.3827 3.03918 11.3101 3.04916C9.10785 3.35483 7.36726 5.08635 7.05252 7.2859C7.01261 7.55891 7.00626 7.66231 7.00626 8.00063C7.00626 8.33896 7.01261 8.44236 7.05252 8.71537C7.35275 10.8133 8.96273 12.5058 11.038 12.9068C11.3872 12.9739 11.6013 12.9938 11.9995 12.9938C12.3378 12.9938 12.4403 12.9875 12.7142 12.9476C14.8122 12.6473 16.5047 11.0374 16.9056 8.96209C16.9736 8.61197 16.9927 8.39791 16.9927 8.00063C16.9927 7.6732 16.9863 7.56617 16.9509 7.31129C16.6462 5.10993 14.9128 3.36753 12.7142 3.0537C12.628 3.041 12.5128 3.02648 12.4575 3.02104C12.3605 3.01107 11.7863 3.00109 11.7137 3.00834ZM11.5822 14.0106C11.3781 14.0242 11.1423 14.046 10.9927 14.065C9.76908 14.2192 8.6108 14.6492 7.57769 15.3349C6.39402 16.1195 5.42622 17.2251 4.80581 18.4995C4.54368 19.0383 4.34685 19.5934 4.20626 20.1866C4.15638 20.3997 4.14368 20.5204 4.16273 20.6065C4.20173 20.7888 4.34685 20.9376 4.53007 20.9848C4.57815 20.9966 5.39901 20.9984 11.9995 20.9984C18.5999 20.9984 19.4208 20.9966 19.4688 20.9848C19.6457 20.9394 19.7854 20.8025 19.8317 20.6265C19.8516 20.5512 19.8489 20.4433 19.8226 20.3254C19.5305 18.9757 18.9246 17.7721 18.0076 16.719C17.8625 16.5521 17.4788 16.1666 17.3092 16.0179C16.7668 15.5399 16.2217 15.1707 15.5913 14.8541C14.6598 14.3852 13.7319 14.124 12.6571 14.0269C12.5038 14.0133 11.7246 14.0015 11.5822 14.0106Z"
        fill={fillColor}
      />
    </svg>
  );
};
